const isBrowser = () => typeof window !== 'undefined';
const isTouchDevice = () => isBrowser() && 'ontouchstart' in window;
const prepareClassName = (name) => String(name).replace(/\s/g, '-').toLowerCase();
const parsedJsonOrNull = (data) => {
    let result = null;
    try {
        result = JSON.parse(data);
    }
    catch (err) {
        if (process.env.NODE_ENV === 'development') {
            console.warn('Catch exception on parse value with JSON.parse:', err);
        }
    }
    return result;
};
const DEFER_TIMEOUT = 1000;
const getDeferFunctionImplementation = (timeout) => {
    const isRequestIdleCallbackAvailable = 'requestIdleCallback' in window;
    const deferFunction = isRequestIdleCallbackAvailable
        ? window.requestIdleCallback
        : setTimeout;
    const deferParams = isRequestIdleCallbackAvailable ? { timeout } : timeout;
    return {
        deferFunction,
        deferParams,
    };
};
const removeJsOrCss = (filename, isJs = true) => {
    const tags = document.getElementsByTagName(isJs ? 'script' : 'link');
    for (let i = tags.length; i >= 0; i -= 1) {
        if (tags[i] &&
            tags[i].getAttribute(isJs ? 'src' : 'href') !== null &&
            tags[i].getAttribute(isJs ? 'src' : 'href').indexOf(filename) !== -1) {
            tags[i].parentNode.removeChild(tags[i]);
        }
    }
};
const removeElementsByClassName = (className) => {
    const elements = document.querySelectorAll(`.${className}`);
    elements.forEach((element) => {
        element.remove();
    });
};
const removeElementById = (id) => {
    const elem = document.querySelector(`#${id}`);
    if (elem) {
        elem.remove();
    }
};
const runOnUserInteraction = (callback, timeout = DEFER_TIMEOUT) => {
    const USER_INTERACTION_EVENTS = ['mousemove', 'touchmove'];
    const { deferFunction, deferParams } = getDeferFunctionImplementation(timeout);
    const eventHandler = () => {
        deferFunction(callback, deferParams);
        USER_INTERACTION_EVENTS.forEach((eventName) => {
            window.removeEventListener(eventName, eventHandler);
        });
    };
    USER_INTERACTION_EVENTS.forEach((eventName) => {
        window.addEventListener(eventName, eventHandler);
    });
};

export { isBrowser, isTouchDevice, parsedJsonOrNull, prepareClassName, removeElementById, removeElementsByClassName, removeJsOrCss, runOnUserInteraction };
